import service from '../request/index'

// 搜索记录列表
export function searchRecordList () {
  return service({
    url: '/es/resource/searchRecord/searchRecordList',
    method: 'GET',
  })
}

// 热搜词
export function hotWord () {
  return service({
    url: '/es/resource/word/hot/word',
    method: 'GET',
  })
}

// 分词搜索
export function search (data) {
  return service({
    url: '/es/resource/lib/search',
    method: 'POST',
    data
  })
}


// 删除一条搜索记录
export function deleteOneSearchRecord (data) {
  return service({
    url: '/es/resource/searchRecord/delete',
    method: 'delete',
    params: data
  })
}



// 删除本人全部搜索记录
export function deleteAllSearchRecord () {
  return service({
    url: '/es/resource/searchRecord/deleteAll',
    method: 'delete',
  })
}
